// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DescriptionPhoto_wrapper__2ElE3"};